var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "suc-select-component",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: _vm.$t("components.fields.year"),
            options: _vm.options,
            value: _vm.value,
          },
          on: { input: _vm.onChangeField },
          scopedSlots: _vm._u([
            {
              key: "no-options",
              fn: function () {
                return [_vm._v(_vm._s(_vm.$t("components.fields.no_options")))]
              },
              proxy: true,
            },
          ]),
        },
        "suc-select-component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }